/**
 * @desc Loading API
 *  打开 Loading.show();
 *  隐藏 Loading.hide();
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Spin, Icon } from 'antd';
import styleUser from './style/index.less';
// import { LoadingIcon } from './LoadingIcon';

const LoadingIndicator = <Icon type="loading" style={{ fontSize: 26, fontWeight: 'bold' }} spin />;

// const LoadingIndicator = <LoadingIcon style={{ fontSize: 26, fontWeight: 'bold' }} spin />

class LoadingDom extends React.Component {
  constructor () {
    super();
    this.state = {
      show: false,
      showNum: 0,
    };
  }

  hide = () => {
    let { showNum } = this.state;
    showNum -= 1;
    if (showNum <= 0) {
      this.setState({
        show: false,
        showNum: 0,
      });
    }
    else {
      this.setState({
        showNum,
      });
    }
  }

  show = () => {
    let { showNum } = this.state;
    showNum += 1;
    this.setState({
      show: true,
      showNum,
    });
  }

  render () {
    const { show } = this.state;
    const c1 = styleUser.loading;
    const c2 = !show && styleUser.hide;
    return (
      <div className={`${c1} ${c2}`}>
        <Spin
          tip="数据加载中......"
          size="large"
          delay={500}
          indicator={LoadingIndicator}
        />
        <div className="mark" />
      </div>
    );
  }
}

let componentRef = '';
const createLoading = new Promise(
  () => {
    const div = document.createElement('div');
    div.className = 'souche--loading';
    document.body.appendChild(div);
    const component = React.createElement(LoadingDom, {
      ref: (ref) => {
        componentRef = ref;
      },
    });
    ReactDOM.render(component, div);
  }
);
const Loading = {
  show: () => {
    if (!componentRef) {
      createLoading().then(() => {
        componentRef.show();
      })
    }
    else {
      componentRef.show();
    }
  },
  hide: () => {
    if (!componentRef) {
      console.error('未启用LOADING，请先使用show方法启用，再使用hide方法隐藏');
    }
    else {
      componentRef.hide();
    }
  },
};

export default Loading;
